import * as React from 'react'
import IndexPage from '../components/index-page/index-page'

// markup
const Index = () => {
  return <IndexPage></IndexPage>
}

export default Index
